import { render, staticRenderFns } from "./EmtaRegistration.vue?vue&type=template&id=4f3f5068&scoped=true"
import script from "./EmtaRegistration.vue?vue&type=script&lang=js"
export * from "./EmtaRegistration.vue?vue&type=script&lang=js"
import style0 from "./EmtaRegistration.vue?vue&type=style&index=0&id=4f3f5068&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f5068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3f5068')) {
      api.createRecord('4f3f5068', component.options)
    } else {
      api.reload('4f3f5068', component.options)
    }
    module.hot.accept("./EmtaRegistration.vue?vue&type=template&id=4f3f5068&scoped=true", function () {
      api.rerender('4f3f5068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emta/EmtaRegistration.vue"
export default component.exports